import { getAuthCookie, setAuthCookie, removeAuthCookie } from '@/utils/cookies'

export interface Tokens {
  access_token: string
  access_token_expiry: number
  refresh_token: string
  refresh_token_expiry: number
  session_started_at: number
  account_type?: string
  email?: string
  id?: number
}

let tokens: Tokens | null = null
let refreshPromise: Promise<void> | null = null

function parseCookie(raw: string): Tokens | null {
  try {
    const parsed = JSON.parse(raw) as Partial<Tokens> & Record<string, unknown>
    if (
      typeof parsed.access_token === 'string' &&
      typeof parsed.refresh_token === 'string' &&
      typeof parsed.access_token_expiry === 'number' &&
      typeof parsed.refresh_token_expiry === 'number' &&
      typeof parsed.session_started_at === 'number'
    ) {
      return parsed as Tokens
    }
    return null
  } catch {
    return null
  }
}

export function getTokens(): Tokens | null {
  if (!tokens && typeof window !== 'undefined') {
    const authCookie = getAuthCookie()
    if (authCookie) {
      tokens = parseCookie(authCookie)
    }
  }
  return tokens
}

export function getAccessToken(): string | null {
  return getTokens()?.access_token ?? null
}

export function setTokens(next: Tokens | null): void {
  tokens = next
  if (next) {
    setAuthCookie(JSON.stringify(next), next.session_started_at)
  } else {
    removeAuthCookie()
  }
}

export async function refreshOnce(doRefresh: () => Promise<Tokens>): Promise<void> {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const next = await doRefresh()
        setTokens(next)
      } finally {
        refreshPromise = null
      }
    })()
  }
  await refreshPromise
}
